import { Grid, Typography, MenuItem, Box } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import { TextField, Select, Tooltip } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { useSelector } from 'react-redux';
import { ticketService } from '../../model/_service';
import { useTranslation } from "react-i18next";
import { Skeleton } from '@material-ui/lab';

const OutlinedTextFiled = withStyles((theme) => ({
  root: {
    "& input::placeholder": {
      fontSize: "0.75rem !important",
    },
    "& .MuiOutlinedInput-input": {
      padding: "0.62rem  !important",
      color: theme.palette.eDark?.base + " !important"
    },
    "& .MuiInputBase-input": {
      fontSize: "0.75rem !important",
      color: theme.palette.eDark?.base + " !important"
    },
    "& .MuiInputBase-input:focus": {
      fontSize: "1rem !important",
    },
    "& .MuiFormHelperText-root.Mui-error": {
      color: theme.palette.eDanger?.dark,
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.eDanger?.dark
    },
    "& ::placeholder": {
      color: theme.palette.eDark?.base
    }
  },
}))(TextField);

const DropDown = withStyles((theme) => ({
  root: {
    padding: "0.46rem  !important",
    fontSize: "0.75rem !important",
  },
}))(Select);
export const STYLED_MENU_ITEM = withStyles((theme) => ({
  root: {
    justifyContent: "flex-start !important",
    fontSize: "0.8rem",
    whiteSpace: "normal"
  },
}))(MenuItem);
const useStyles = makeStyles((theme) => ({
  alertStyle: {
    color: theme.palette.eDanger.dark,
    backgroundColor: theme.palette.eDanger.light,
  },
  errorMsgRightAlign: {
    "& .MuiFormHelperText-contained": {
      marginLeft: 0,
      marginRight: 0,
    },
  },
  verifyRightAlign: {
    justifyContent: "flex-end",
    "& .MuiLink-button": {
      color: theme.palette.ePrimary.base
    }
  },
  displayFlex: {
    display: "flex"
  },
  phoneInputPadding: {
    "& #registeredCell_Id": {
      padding: 7,
      borderRadius: 4,
      borderColor: "lightgrey !important",
      borderWidth: "thin",
    }
  },
  errorMsgRightAlignMobile: {
    marginLeft: 0,
    marginRight: 0,
    display: "flex",
    justifyContent: "flex-end"
  },
  userVerified: {
    color: theme.palette.eSecondary.base,
  },
  userVefiy: {
    whiteSpace: "nowrap",
  },
  verifyIcon: {
    fontSize: "small"
  },
  boxPaddingRight: {
    paddingRight: "1rem !important",
    [theme.breakpoints.down("xs")]: {
      paddingRight: "0 !important",
    },
  },
  verifyTopPadding: {
    paddingTop: "0.313rem"
  },
  asterisk: {
    color: theme.palette.eDanger?.dark
  },
  defaultColor: {
    color: theme?.palette?.eMedium?.base + "!important",
  },
  errorColor: {
    color: theme.palette.eDanger?.dark
  },
  appInfoPadBottom: {
    paddingBottom: 7
  }
}))

function EApplicantInfoGroup(props) {
  const {
    tarrifType,
    setTarrifType,
    Load,
    setLoad,
    meterType,
    setMeterType,
    idType,
    setIdType,
    idValue,
    setIdValue,
    idTypeRequire,
    setidTypeRequire,
    idValueRequire,
    setidValueRequire,
    connectionTypeRequire,
    setconnectionTypeRequire,
    connectionType,
    setconnectionType,
    setConnectionTypeCode,
    setDropDownData,
    dropDownData,
    setDocumentList,
    setDocumentCodeList,
    setIdTypeCode,
    setTinTypeCode,
    setTarrifTypeCode,
    setMeterTypeCode,
    idValueError, 
    setidValueError,
    idTypeCode,
    tinTypeCode,
    tinValue,
    tinValueRequire,
    setTinValueRequire,
    tinValueError,
    setTinValueError,
    setTinValue,
    existingCustomer,
    MasterDataDetailsError,
    existingCustomerIDRequire,
    existingCustomerNotValid,
    masterDataIdValue,
    masterDataTinValue
  } = props;

  const classes = useStyles();

  const applicantLabels = useSelector((state) => state?.labels?.data?.getLabels?.E_APPLICANT_DETAILS);
  const userNameLength = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.USERNAME_LENGTH);
  const languageCode = useSelector((store) => store?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE);
  const nationalIdLength = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_NATIONAL_ID_LENGTH);
  const drivingLicenceLength = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_DRIVING_LICENCE_LENGTH);
  const passportNumberLength = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_PASSPORT_LENGTH);
  const mobileRegex = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_APPLICANT_MOBILE_REGEX);
  const nidRegex = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_APPLICANT_NID_REGEX);
  const tinMinValue = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_TIN_MIN_LIMIT);
  const tinMaxValue = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_TIN_MAX_LIMIT);

  const { t: applicantLabel, ready: applicantLabelReady } = useTranslation("label-E_APPLICANT_DETAILS");
  const { t: connectionTarrifTypeContent, ready: connectionTerifContentReady } = useTranslation("content-CONNECTION_TYPE_TARRIF_TYPE");
  const { t: documentContent, ready: documentContentReady } = useTranslation("content-E_UPLOAD_DOCUMENTS");

  const [tarrifTypeList, settarrifTypeList] = useState([]);
  const [idTypeList, setidTypeList] = useState([]);
  const [meterTypeList, setmeterTypeList] = useState([]);

  useEffect(() => {
    if (languageCode) {
      if(dropDownData.length === 0) {
        ticketService
          .getDropdownpData("E_CONNECTION_TYPES", languageCode)
          .then((res) => {
            setDropDownData(res.data.data.getDropdownData);
          })
          .catch(() => {
            setDropDownData(null);
          });
      }
      ticketService
        .getDropdownpData("E_ID_TYPES", languageCode)
        .then((res) => {
          setidTypeList(res.data.data.getDropdownData);
        })
        .catch(() => {
          setidTypeList(null);
        });

      ticketService
        .getDropdownpData("E_METER_TYPES", languageCode)
        .then((res) => {
          setmeterTypeList(res.data.data.getDropdownData);
        })
        .catch(() => {
          setmeterTypeList(null);
        });
    }
  }, [languageCode]);

function alphabeticalOrder(arr) {
  return arr && arr?.sort((a, b) => a.dropDownValue < b.dropDownValue ? -1 : 1)
}
useEffect(()=>{
  alphabeticalOrder(dropDownData)
},[dropDownData])
  const handleConnectionTypeChange = (e) => {
    let keyLocal = dropDownData.find((element) => element.dropDownValue === e.target.value)?.dropDownCode;
    if (keyLocal) {
      var contentList = documentContentReady ? documentContent("E_REQUIRED_DOCUMENTS_" + keyLocal) : '';
      setDocumentCodeList(contentList?.question?.split(","));
      let docNameList = contentList?.answer?.split("#");
      let emptyObj = [];
      if(docNameList) {
        docNameList.map((item, index) => {
          emptyObj.push({ index: index, files: [] })
        })
      }
      setDocumentList(emptyObj);
    }
    setconnectionType(e.target.value);
    setTarrifType("")
  };

  useEffect(() => {
    if(connectionType != ""){
      let keyLocal = dropDownData.find((element) => element.dropDownValue === connectionType)?.dropDownCode;
      setConnectionTypeCode(keyLocal);
      var contentList = connectionTerifContentReady ? connectionTarrifTypeContent(keyLocal) : '';
      const tarrifCode = contentList?.question?.split(",")
      const tarrifDescription = contentList?.answer?.split("#")
      var tarrifList = tarrifCode?.map((item, index) => {
        return {dropDownCode: tarrifCode[index], dropDownValue: tarrifDescription[index]}
      })
      tarrifList = tarrifList?.sort((a,b) => (a.dropDownCode > b.dropDownCode) ? 1 : ((b.dropDownCode > a.dropDownCode) ? -1 : 0))
      settarrifTypeList(tarrifList)
    }
  }, [dropDownData,connectionType])
  

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "Load") {
      const re = RegExp(mobileRegex)
      if (value === "" || re.test(event.target.value)) {
        setLoad(event.target.value);
      }
    } else if (name === "idValue") {
      setIdValue(event.target.value);
    }else if(name === "tinvalue"){
      setTinValue(event.target.value);
    }
  };

  const handleTarrifChange = (e) => {
    setTarrifType(e.target.value)
    tarrifTypeList.map(item => {
      if(item?.dropDownValue === e.target.value) {
        setTarrifTypeCode(item?.dropDownCode);
      }
    })
  }

  const handleMeterTypeChange = (e) => {
    setMeterType(e.target.value)
    meterTypeList.map(item => {
      if(item?.dropDownValue === e.target.value) {
        setMeterTypeCode(item?.dropDownCode);
      }
    })
  }

  const dropDownMenuProps = {
    disableScrollLock: false,
    anchorOrigin: {
      vertical: "bottom"
    },
    transformOrigin: {
      vertical: "top"
    },
    getContentAnchorEl: null
  }

  const handleIDTypeChange = (e) => {
    setIdType(e.target.value);
    setIdValue("")
    idTypeList.map(item => {
      if(item?.dropDownValue === e.target.value) {
        setIdTypeCode(item?.dropDownCode);
      }
    })
  }
const TinvalueBlur = ()=>{
  if(tinValue){
    setTinValueRequire(false)
    if(tinValue.length < Number(tinMinValue)){
      setTinValueError(true)
    }else{
      setTinValueError(false)
    }
  }else{
    setTinValueRequire(true)
  }
}
  const IDValueBlur = () => {
    if (idValue) {
      setidValueRequire(false);
      if (idTypeCode == "CM_NID") {
        if(RegExp(nidRegex).test(idValue)) {
          setidValueError(false);
        } else {
          setidValueError(true);
        }
      } else if (idTypeCode == "CM_SMRT" && idValue.length == Number(nationalIdLength)) {
        setidValueError(false);
      } else if(idTypeCode == "DL" || idValue.length == Number(drivingLicenceLength)){
        setidValueError(false);
      } else if(idTypeCode == "PASSPORT" || idValue.length == Number(passportNumberLength)){
        setidValueError(false);
      } else {
        setidValueError(true);
      }
    } else {
      setidValueRequire(true);
    }
  };

  const ConnectionTypeBlur = () => {
    if (connectionType == "") {
      setconnectionTypeRequire(true)
    } else {
      setconnectionTypeRequire(false)
    }
  }

  const IDTypeBlur = () => {
    if (idType == "") {
      setidTypeRequire(true)
    } else {
      setidTypeRequire(false)
    }
  }


  return (
    <Grid container spacing={0} direction="row">
      <Grid item xs={12} sm={6} md={6}>
        <Box className={classes.boxPaddingRight}>
          <Grid container spacing={1} direction="row">
            <Grid item xs={12}>
            {
              applicantLabelReady ?
              <Typography variant="caption">
                {applicantLabel("E_APPLICANT_CONNECTION_TYPE")}<span className={classes.asterisk}>*</span>
              </Typography>
              : <Skeleton />
            }
              <DropDown
                fullWidth
                variant="outlined"
                labelId="label"
                id="select"
                value={connectionType}
                className={!connectionType && classes.defaultColor}
                onChange={handleConnectionTypeChange}
                onBlur={ConnectionTypeBlur}
                renderValue={(selected) => {
                  if (selected?.length == 0) {
                    return applicantLabelReady ? applicantLabel("E_APPLICANT_CONNECTION_TYPE_PLACEHOLDER") : ''
                  }
                  return selected;
                }}
                displayEmpty
                disabled={MasterDataDetailsError||existingCustomerIDRequire||existingCustomerNotValid}
                MenuProps={dropDownMenuProps}
                error={connectionTypeRequire}
              >
                {dropDownData?.length && dropDownData?.map((item, k) => {
                  return (
                    <STYLED_MENU_ITEM value={item.dropDownValue}>
                      {item.dropDownValue}
                    </STYLED_MENU_ITEM>
                  );
                })}
              </DropDown>
              {
                applicantLabelReady ?
              <Typography
                variant="caption"
                className={["marginleftError", classes.errorColor]}
              >
                {connectionTypeRequire === true ? (
                  applicantLabel("E_APPLICANT_CONNECTION_TYPE") + applicantLabel("E_APPLICANT_REQUIRED")
                ) : (
                  <div>&nbsp;</div>
                )}
              </Typography>
              : <Skeleton />
              }
            </Grid>
            <Grid item xs={12}>
            {
              applicantLabelReady ?
              <Typography variant="caption">
                {applicantLabel("E_APPLICANT_TARRIF_TYPE")}
              </Typography>
              : <Skeleton />
            }
              {tarrifTypeList?.length == 0 ?
                <Tooltip title={applicantLabel("E_CONNECTION_TYPE_TOOLTIP")}>
                  <DropDown
                    fullWidth
                    variant="outlined"
                    labelId="label"
                    id="select"
                    disabled={true || MasterDataDetailsError||existingCustomerIDRequire}
                    value={tarrifType}
                    className={!tarrifType && classes.defaultColor}
                    onChange={handleTarrifChange}
                    renderValue={(selected) => {
                      if (selected?.length == 0) {
                        return applicantLabelReady ? applicantLabel("E_APPLICANT_TARRIFTYPE_PLACEHOLDER") : ""
                      }
                      return selected;
                    }}
                    displayEmpty
                    MenuProps={dropDownMenuProps}
                  >
                  </DropDown>
                </Tooltip>
                :
                <DropDown
                  fullWidth
                  variant="outlined"
                  labelId="label"
                  id="select"
                  value={tarrifType}
                  className={!tarrifType && classes.defaultColor}
                  onChange={handleTarrifChange}
                  disabled={MasterDataDetailsError||existingCustomerIDRequire||existingCustomerNotValid}
                  renderValue={(selected) => {
                    if (selected?.length == 0) {
                      return applicantLabelReady ? applicantLabel("E_APPLICANT_TARRIFTYPE_PLACEHOLDER") : ''
                    }
                    return selected;
                  }}
                  displayEmpty
                  MenuProps={dropDownMenuProps}
                >
                  {tarrifTypeList?.length && tarrifTypeList?.map((item, k) => {
                    return (
                      <STYLED_MENU_ITEM value={item.dropDownValue}>
                        {item.dropDownValue}
                      </STYLED_MENU_ITEM>
                    );
                  })}
                </DropDown>}
              <div>&nbsp;</div>
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid item xs={12} sm={6} md={6} className={classes.appInfoPadBottom}>
        <Box className={classes.boxPaddingRight}>
          <Grid container spacing={1} direction="row">
            <Grid item xs={12}>
            {
              applicantLabelReady ?
              <Typography variant="caption">
                {applicantLabel("E_APPLICANT_METER_TYPE")}
              </Typography>
              : <Skeleton />
            }
              <DropDown
                fullWidth
                variant="outlined"
                labelId="label"
                id="select"
                value={meterType}
                className={!meterType && classes.defaultColor}
                onChange={handleMeterTypeChange}
                renderValue={(selected) => {
                  if (selected?.length == 0) {
                    return applicantLabelReady ? applicantLabel("E_APPLICANT_METERTYPE_PLACEHOLDER") : ''
                  }
                  return selected;
                }}
                displayEmpty
                disabled={MasterDataDetailsError||existingCustomerIDRequire||existingCustomerNotValid}
                MenuProps={dropDownMenuProps}
              >
                {meterTypeList?.length && meterTypeList?.map((item, k) => {
                  return (
                    <STYLED_MENU_ITEM value={item.dropDownValue}>
                      {item.dropDownValue}
                    </STYLED_MENU_ITEM>
                  );
                })}
              </DropDown>
              <div>&nbsp;</div>
            </Grid>
            <Grid item xs={12}>
            {
              applicantLabelReady ?
              <Typography variant="caption">
                {applicantLabel("E_APPLICANT_LOAD")}
              </Typography>
              : <Skeleton />
            }
              <OutlinedTextFiled
                variant="outlined"
                name="Load"
                fullWidth
                value={Load}
                onChange={handleChange}
                autoComplete="off"
                disabled={MasterDataDetailsError||existingCustomerIDRequire||existingCustomerNotValid}
                placeholder={applicantLabelReady ? applicantLabel("E_APPLICANT_LOAD_PLACEHOLDER") : ""}
                className={[classes.errorMsgRightAlign]}
              />
              <div>&nbsp;</div>
            </Grid>
          </Grid>
        </Box>
      </Grid>

      <Grid item xs={12} sm={6} md={6}>
        <Box className={classes.boxPaddingRight}>
          <Grid container spacing={1} direction="row">
            <Grid item xs={12}>
            {
              applicantLabelReady ?
              <Typography variant="caption">
                {applicantLabel("E_APPLICANT_ID_VALUE")}<span className={classes.asterisk}>*</span>
              </Typography>
              : <Skeleton />
            }
            {existingCustomer=="yes" ? 
              <OutlinedTextFiled
                variant="outlined"
                name="idValue"
                fullWidth
                maxLength={Number(userNameLength)}
                value={masterDataIdValue}
                disabled={true}
                inputProps={{
                  maxLength: (idTypeCode == "CM_NID" || idTypeCode == "CM_SMRT") ? Number(nationalIdLength) : (idTypeCode == "DL") ? Number(drivingLicenceLength) : Number(passportNumberLength),
                }}
                autoComplete="off"
                placeholder={applicantLabelReady ? applicantLabel("E_APPLICANT_ID_VALUE_PLACEHOLDER") : ''}
                className={[classes.errorMsgRightAlign]}
              />
            :
            <OutlinedTextFiled
            variant="outlined"
            name="idValue"
            fullWidth
            maxLength={Number(userNameLength)}
            value={idValue}
            onChange={handleChange}
            onBlur={IDValueBlur}
            inputProps={{
              maxLength: (idTypeCode == "CM_NID" || idTypeCode == "CM_SMRT") ? Number(nationalIdLength) : (idTypeCode == "DL") ? Number(drivingLicenceLength) : Number(passportNumberLength),
            }}
            error={idValueRequire || idValueError}
            autoComplete="off"
            helperText={
              idValueRequire === true && applicantLabelReady ? (
                applicantLabel("E_APPLICANT_ID_VALUE") + applicantLabel("E_APPLICANT_REQUIRED")
              ) : idValueError == true ? applicantLabel("E_APPLICANT_ID_VALUE") + applicantLabel("E_APPLICANT_NOT_VALID"): (
                <div>&nbsp;</div>
              )
            }
            placeholder={applicantLabelReady ? applicantLabel("E_APPLICANT_ID_VALUE_PLACEHOLDER") : ''}
            className={[classes.errorMsgRightAlign]}
          />}
            
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        <Box className={classes.boxPaddingRight}>
          <Grid container spacing={1} direction="row">
            <Grid item xs={12}>
            {
              applicantLabelReady ?
              <Typography variant="caption">
               {applicantLabel("E_TIN_NUMBER")}
              </Typography>
              : <Skeleton />
            }
            {existingCustomer=="yes"?
              <OutlinedTextFiled
                variant="outlined"
                name="tinvalue"
                fullWidth
                maxLength={Number(userNameLength)}
                value={masterDataTinValue}
                disabled={true}
                inputProps={{
                  maxLength: ( Number(tinMaxValue)),
                }}
                autoComplete="off"
                placeholder={applicantLabelReady ? applicantLabel("E_TIN_PLACEHOLDER") : ''}
                className={[classes.errorMsgRightAlign]}
              />: <OutlinedTextFiled
              variant="outlined"
              name="tinvalue"
              fullWidth
              maxLength={Number(userNameLength)}
              value={tinValue}
              onChange={handleChange}
              onBlur={TinvalueBlur}
              inputProps={{
                maxLength: ( Number(tinMaxValue)),
              }}
              error={tinValueError}
              autoComplete="off"
              helperText={
                tinValueError == true ? applicantLabel("E_TIN_NUMBER") + applicantLabel("E_APPLICANT_NOT_VALID"): (
                  <div>&nbsp;</div>
                )
              }
              placeholder={applicantLabelReady ? applicantLabel("E_TIN_PLACEHOLDER") : ''}
              className={[classes.errorMsgRightAlign]}
            />}
                       </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  )
}

export default EApplicantInfoGroup